import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getMenuDetails } from "../Services/menu-service";
import { routeConfig } from "../config/routeConfig";

const MainComponent = (props) => {
  console.log("props_MainComponent", props);
  const childRef = props.childRef;
  const location = useLocation();

  // Removed unused setKey effect
  const hasAccess = (menuPath, component, props = {}, requiresRef = false) => {
    const menuAccess = sessionStorage.getItem("UserAccess");
    const labels = getMenuDetails(menuAccess, menuPath);
    
    if (labels?.title !== undefined) {
      const Component = component;
      const componentProps = {
        ...props,
        ...(requiresRef && { ref: childRef }),
        key: `${component.name}-${menuPath}-${JSON.stringify(props)}` // Unique key per component+route+props
      };
      return <Component {...componentProps} />;
    }
    return <Navigate to="/unauthorized" />;
  };

  const renderRoute = (route) => {
    if (route.requiresAuth === false) {
      const Component = route.component;
      const componentProps = {
        ...route.props,
        ...(route.requiresRef && { ref: childRef }),
        key: `${Component.name}-${route.path}-${JSON.stringify(route.props || {})}` // Unique key per component+route+props
      };
      return <Component {...componentProps} />;
    }
    
    return hasAccess(
      route.access,
      route.component,
      route.props,
      route.requiresRef
    );
  };

  return (
    <Routes>
      {routeConfig.map((route) => (
        <Route
          key={`${route.path}-${JSON.stringify(route.props || {})}`}
          path={route.path}
          element={renderRoute(route)}
        />
      ))}
    </Routes>
  );
};

export default MainComponent;